import { DocumentValidation, ValidationQuestion } from "../interfaces/document-category.interface";
import { GeneralUtilities } from "./general";

export class DocumentValidationQuestions {
  public static address_web: Partial<ValidationQuestion>[] = [
    {
      type: "radio-textbox",
      question: "¿Existe un registro en el sitio?",
      control: "cfe_record_exist",
      options: [
        { label: "Sí hay registro", value: { value: "si", disable_form: false } },
        { label: "No hay registro", value: { value: "no", disable_form: true, question_call: "missing_record" } },
        { label: "Error en sitio", value: { value: "other", disable_form: true, question_call: "missing_record" } },
      ],
      answer: undefined,
      alternative_question: "Describe el error",
      label: "Descripción error",
      page: 1,
    },
    {
      type: "radio",
      question: "¿El titular del servicio coincide entre el registro y el comprobante?",
      control: "same_titular",
      options: [
        { label: "Sí", value: { value: "si" } },
        { label: "No", value: { value: "no", rejected_client: true } },
      ],
      answer: undefined,
      page: 1,
    },
    {
      type: "radio",
      question: "¿El total a pagar coincide entre el registro y el comprobante?",
      control: "same_total",
      options: [
        { label: "Sí", value: { value: "si" } },
        { label: "No", value: { value: "no", rejected_client: true } },
      ],
      answer: undefined,
      page: 1,
    },
    {
      type: "radio",
      question: "¿El número de servicio coincide entre el registro y el comprobante?",
      control: "same_service_number",
      options: [
        { label: "Sí", value: { value: "si" } },
        { label: "No", value: { value: "no", rejected_client: true } },
      ],
      answer: undefined,
      page: 2,
    },
    {
      type: "radio",
      question: "¿El domicilio coincide entre el registro y el comprobante?",
      control: "same_address",
      options: [
        { label: "Sí", value: { value: "si" } },
        { label: "No", value: { value: "no", rejected_client: true } },
      ],
      answer: undefined,
      page: 2,
    },
    {
      type: "radio",
      question: "¿El consumo es constante?",
      control: "constant_consumption",
      options: [
        { label: "Sí es constante", value: { value: "si" } },
        { label: "No es constante", value: { value: "no", question_call: "not_constant_consumption" } },
        { label: "No hay historial de consumo", value: { value: "no hay datos" } },
      ],
      answer: undefined,
      page: 2,
    },
    {
      type: "radio",
      question: "¿El comprobante de domicilio está vigente?",
      control: "current_proof",
      options: [
        { label: "Sí", value: { value: "si" } },
        { label: "No", value: { value: "no", incident_current: true } },
      ],
      answer: undefined,
      page: 3,
    },
    {
      type: "textbox",
      question: "Pega el link del sitio visitado",
      control: "address_link_visited",
      answer: undefined,
      label: "Link del Sitio Visitado",
      page: 3,
    },
    {
      type: "file",
      question: "Carga la captura de pantalla del sitio",
      additional_information: "Carga una captura de pantalla con los resultados de la validación.",
      control: "address_file_proof",
      answer: undefined,
      file_extensions: [".jpg", ".png", ".jpeg"],
      file_accept: ["image/png, image/jpg", "image/jpeg"],
      documentable_type: "",
      documentable_id: "",
      file_error: "",
      file_category: "",
      waiting: false,
      page: 3,
    },
  ];

  public static address_information: Partial<ValidationQuestion>[] = [
    {
      type: "textbox",
      question: "Escribe el domicilio que aparece en el comprobante.",
      control: "address_proof",
      answer: undefined,
      label: "Domicilio en Comprobante",
      additional_information:
        "Calle, núm. exterior, núm. interior (opc), col, municipio o delegación, ciudad y código postal.",
      pattern: ".*[0-9]{5}.*",
      pattern_error: "Ingresa un código postal de 5 dígitos",
      page: 1,
    },
    {
      type: "radio-textbox",
      question: "¿El comprobante de domicilio está a nombre del solicitante?",
      control: "titular_proof",
      answer: undefined,
      options: [
        { label: "Sí", value: { value: "si", rating: 1 } },
        { label: "No", value: { value: "other", rating: 0 } },
      ],
      label: "Nombre del titular en Comprobante",
      alternative_question: "Escribe el nombre del titular que aparece en el comprobante.",
      page: 1,
    },
    {
      type: "radio-card",
      question: "¿El domicilio del comprobante coincide con el declarado?",
      formatted_question:
        "¿El domicilio del comprobante coincide con el <span class='warm-blue-color'>declarado</span>?",
      control: "declarated_address_coincidence",
      answer: undefined,
      title: "Declarado",
      data: "",
      options: [
        { label: "Sí", value: { value: "si", rating: 1 } },
        { label: "No", value: { value: "no", rating: 0 } },
      ],
      page: 2,
    },
    {
      type: "card-options",
      question: "Selecciona el domicilio en Buró de Crédito que corresponda al del comprobante",
      formatted_question:
        "Selecciona el domicilio en <span class='warm-blue-color'>Buró de Crédito</span> que corresponda al del comprobante",
      control: "address_buro_proof",
      answer: undefined,
      title: "Buró de Crédito",
      options: [],
      auxiliar_cards: [],
      rating: 1,
      alternative_question:
        "Calle, núm. exterior, núm. interior (opc), col, municipio o delegación, ciudad y código postal.",
      page: 3,
    },
    {
      type: "card-options",
      question: "Selecciona el domicilio en Buró de Crédito que corresponda al declarado",
      formatted_question:
        "Selecciona el domicilio en <span class='warm-blue-color'>Buró de Crédito</span> que corresponda al <span class='warm-blue-color'>declarado</span>",
      control: "same_declarated_proof",
      answer: undefined,
      title: "Buró de Crédito",
      rating: 0.5,
      options: [],
      auxiliar_cards: [
        {
          title: "Domicilio Declarado",
          data: "",
        },
      ],
      alternative_question:
        "Calle, núm. exterior, núm. interior (opc), col, municipio o delegación, ciudad y código postal.",
      page: 4,
    },
  ];

  public static qr_code: Partial<ValidationQuestion>[] = [
    {
      type: "image-options",
      question: "Escanéa el código QR del comprobante con tu celular y registra el resultado.",
      control: "qr_scan",
      answer: undefined,
      options: [
        { label: "Listo", type: "button", value: { value: "código escaneado", disable_form: false, next_page: true } },
        {
          label: "No puedo escanéar el código",
          type: "link",
          value: { value: "error al escanear", disable_form: true, next_page: true },
          question_call: "qr_error",
        },
      ],
      image_url: "https://prestemos-assets.s3.amazonaws.com/gif/QR.gif",
      image_height: "150px",
      page: 1,
    },
    {
      type: "radio-textbox",
      question: "¿Coincide la información del código escaneado con la del comprobante?",
      control: "qr_record_exist",
      options: [
        { label: "Sí coincide la información", value: { value: "si" } },
        { label: "No coincide la información", value: { value: "no", rejected_client: true } },
        { label: "Error en sitio", value: { value: "other", question_call: "missing_record" } },
      ],
      answer: undefined,
      alternative_question: "Describe el error",
      label: "Descripción error",
      page: 2,
    },
  ];

  public static income_information: Partial<ValidationQuestion>[] = [
    {
      type: "textbox",
      question: "Escribe el domicilio que aparece en el Estado de Cuenta.",
      control: "income_address",
      answer: undefined,
      label: "Domicilio",
      additional_information:
        "Calle, núm. exterior, núm. interior (opc), col, municipio o delegación, ciudad y código postal.",
      pattern: ".*[0-9]{5}.*",
      pattern_error: "Ingresa un código postal de 5 dígitos",
      page: 1,
    },
    {
      type: "textbox",
      question: "Escribe la CLABE interbancaria",
      control: "interbank_clabe",
      answer: undefined,
      label: "CLABE interbancaria",
      pattern: "[0-9]{18}",
      min_length: 18,
      max_length: 18,
      pattern_error: "Se requieren 18 caracteres numéricos",
      page: 1,
    },
    {
      type: "card-options",
      question: "Selecciona el domicilio en Buró de Crédito que corresponda al de los Estados de Cuenta",
      formatted_question:
        "Selecciona el domicilio en <span class='warm-blue-color'>Buró de Crédito</span> que corresponda al de los Estados de cuenta",
      control: "address_buro_proof",
      answer: undefined,
      title: "Buró de Crédito",
      options: [],
      rating: 0.5,
      page: 2,
    },
    {
      type: "radio-card",
      question: "¿El domicilio en los Estados de Cuenta coincide con el declarado?",
      formatted_question:
        "¿El domicilio en los Estados de Cuenta coincide con el <span class='warm-blue-color'>declarado</span>?",
      control: "declarated_address_coincidence",
      answer: undefined,
      title: "Domicilio Declarado",
      data: "",
      options: [
        { label: "Sí", value: { value: "si", rating: 0.5 } },
        { label: "No", value: { value: "no", rating: 0 } },
      ],
      page: 3,
    },
  ];

  public static ine_web: Partial<ValidationQuestion>[] = [
    {
      type: "radio-textbox",
      question: "¿Existe un registro en la lista nominal?",
      control: "ine_record_exist",
      options: [
        { label: "Registro correcto del cliente", value: { value: "si", disable_form: false } },
        { label: "NO hay un registro", value: { value: "no", disable_form: true, incident_current: true } },
        {
          label: "Con un trámite posterior",
          value: { value: "exist_newer", disable_form: true, incident_current: true },
        },
        { label: "Error en sitio", value: { value: "other", disable_form: true, question_call: "missing_record" } },
      ],
      answer: undefined,
      alternative_question: "Describe el error",
      label: "Descripción error",
      page: 1,
    },
    {
      type: "radio",
      question: "¿La Identificación está vigente?",
      control: "current_proof",
      options: [
        { label: "Sí", value: { value: "si" } },
        { label: "No", value: { value: "no", incident_current: true } },
      ],
      answer: undefined,
      page: 1,
    },
    {
      type: "file",
      question: "Carga la captura de pantalla del sitio",
      additional_information: "Carga una captura de pantalla con los resultados de la validación.",
      control: "ine_file_proof",
      answer: undefined,
      file_extensions: [".jpg", ".png", ".jpeg"],
      file_accept: ["image/png, image/jpg", "image/jpeg"],
      documentable_type: "",
      documentable_id: "",
      file_error: "",
      file_category: "",
      waiting: false,
      page: 2,
    },
  ];

  public static passport: Partial<ValidationQuestion>[] = [
    {
      type: "calculation",
      question: "",
      control: "mrz-calculation",
      answer: undefined,
      alternative_answer: undefined,
      form_values: undefined,
      mrz_first_line: undefined,
      mrz_second_line: undefined,
    },
  ];

  public static professional_license: Partial<ValidationQuestion>[] = [
    {
      type: "radio-textbox",
      question: "¿Coincide el número de cédula y el nombre del titular con el registro?",
      control: "profesional_licence_record_exist",
      options: [
        { label: "Sí coinciden", value: { value: "si" } },
        { label: "No coinciden", value: { value: "no", question_call: "missing_record" } },
        { label: "No hay registro", value: { value: "no", question_call: "missing_record" } },
        { label: "Error en sitio", value: { value: "other", question_call: "missing_record" } },
      ],
      answer: undefined,
      alternative_question: "Describe el error",
      label: "Descripción error",
      page: 1,
    },
    {
      type: "file",
      question: "Carga la captura de pantalla del sitio",
      additional_information: "Carga una captura de pantalla con los resultados de la validación.",
      control: "professional_licence_file_proof",
      answer: undefined,
      file_extensions: [".jpg", ".png", ".jpeg"],
      file_accept: ["image/png, image/jpg", "image/jpeg"],
      documentable_type: "",
      documentable_id: "",
      file_error: "",
      file_category: "",
      waiting: false,
      page: 1,
    },
  ];

  public static identification_information: Partial<ValidationQuestion>[] = [
    {
      type: "textbox",
      question: "Escribe la información que aparece en la identificación.",
      control: "identification_name",
      answer: undefined,
      expected_answer: undefined,
      warning_message: undefined,
      label: "Nombre completo",
      page: 1,
    },
    {
      type: "textbox-checkbox",
      question: "",
      control: "identification_address",
      answer: undefined,
      label: "Domicilio",
      checkbox_label: "No se muestra el domicilio",
      update_on: "blur",
      pattern: ".*[0-9]{5}.*",
      pattern_error: "Ingresa un código postal de 5 dígitos",
      page: 1,
    },
    {
      type: "textbox-checkbox",
      question: "",
      control: "identification_curp",
      answer: undefined,
      label: "CURP",
      checkbox_label: "No tiene CURP",
      min_length: 18,
      max_length: 18,
      update_on: "change",
      pattern:
        /^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/,
      pattern_error: "Ingresa un CURP valido",
      page: 1,
    },
    {
      type: "card-options",
      question: "Selecciona el domicilio en Buró de Crédito que corresponda al de la identificación",
      formatted_question:
        "Selecciona el domicilio en <span class='warm-blue-color'>Buró de Crédito</span> que corresponda al de la identificación",
      control: "address_buro_proof",
      answer: undefined,
      title: "Buró de Crédito",
      options: [],
      rating: 0.5,
      alternative_question:
        "Calle, núm. exterior, núm. interior (opc), col, municipio o delegación, ciudad y código postal.",
      page: 2,
    },
    {
      type: "radio-card",
      question: "¿El domicilio de la identificación coincide con el declarado?",
      formatted_question:
        "¿El domicilio del comprobante coincide con el <span class='warm-blue-color'>declarado</span>?",
      control: "declarated_address_coincidence",
      answer: undefined,
      title: "Declarado",
      data: "",
      options: [
        { label: "Sí", value: { value: "si", rating: 0.5 } },
        { label: "No", value: { value: "no", rating: 0 } },
      ],
      page: 3,
    },
  ];

  public static income_address_equal_address_proof: Partial<ValidationQuestion> = {
    type: "radio-card",
    question: "¿El domicilio en los Estados de Cuenta coincide con el del comprobante?",
    formatted_question:
      "¿El domicilio en los Estados de Cuenta coincide con el <span class='warm-blue-color'>declarado</span>?",
    control: "same_address",
    answer: undefined,
    title: "Domicilio Declarado",
    data: "",
    options: [
      { label: "Sí", value: { value: "si", rating: 0.5 } },
      { label: "No", value: { value: "no", rating: 0 } },
    ],
    page: 4,
  };

  public static identification_address_equal_address_proof: Partial<ValidationQuestion> = {
    type: "radio-card",
    question: "¿El domicilio en la identificación coincide con el del comprobante?",
    formatted_question:
      "¿El domicilio en los Estados de Cuenta coincide con el <span class='warm-blue-color'>declarado</span>?",
    control: "same_address",
    answer: undefined,
    title: "Domicilio Declarado",
    data: "Rio Elba 20, piso 15.<br> Col. Cuauhtemoc<br>CDMX<br> 06500",
    options: [
      { label: "Sí", value: { value: "si", rating: 0.5 } },
      { label: "No", value: { value: "no", rating: 0 } },
    ],
    page: 4,
  };

  public static linkedn_search: Partial<ValidationQuestion>[] = [
    {
      type: "radio-textbox",
      question: "¿El perfil coincide con el solicitante?",
      additional_information: "Considera la solicitud para conocer más sobre el solicitante.",
      control: "profile_linkedn_exist",
      options: [
        { label: "Sí coincide el perfil", value: { value: "si" } },
        { label: "No coincide el perfil", value: { value: "no", question_call: "missing_record" } },
        { label: "Sin resultado", value: { value: "no", question_call: "missing_record" } },
        { label: "Error en sitio", value: { value: "other", question_call: "missing_record" } },
      ],
      answer: undefined,
      alternative_question: "Describe el error",
      label: "Descripción error",
      page: 1,
    },
    {
      type: "textbox",
      question: "Pega el link del sitio visitado",
      control: "linkedn_link_visited",
      answer: undefined,
      label: "Link del Sitio Visitado",
      page: 2,
    },
    {
      type: "file",
      question: "Carga la captura de pantalla del sitio",
      additional_information: "Carga una captura de pantalla con los resultados de la validación.",
      control: "linkedn_file_proof",
      answer: undefined,
      file_extensions: [".jpg", ".png", ".jpeg"],
      file_accept: ["image/png, image/jpg", "image/jpeg"],
      documentable_type: "",
      documentable_id: "",
      file_error: "",
      file_category: "",
      waiting: false,
      page: 2,
    },
  ];

  public static google_search: Partial<ValidationQuestion>[] = [
    {
      type: "radio-textbox",
      question: "¿Qué tipo de resultados se mostraron acerca del solicitante?",
      control: "profile_google_exist",
      options: [
        { label: "Positivos", value: { value: "positive" } },
        { label: "Negativos", value: { value: "negative", question_call: "missing_record" } },
        { label: "Sin resultados", value: { value: "no_results", question_call: "missing_record" } },
        { label: "Error en sitio", value: { value: "other", question_call: "missing_record" } },
      ],
      answer: undefined,
      alternative_question: "Describe el error",
      label: "Descripción error",
      page: 1,
    },
    {
      type: "textbox",
      question: "Pega el link del sitio visitado",
      control: "google_link_visited",
      answer: undefined,
      label: "Link del Sitio Visitado",
      page: 2,
    },
    {
      type: "file",
      question: "Carga la captura de pantalla del sitio",
      additional_information: "Carga una captura de pantalla con los resultados de la validación.",
      control: "google_file_proof",
      answer: undefined,
      file_extensions: [".jpg", ".png", ".jpeg"],
      file_accept: ["image/png, image/jpg", "image/jpeg"],
      documentable_type: "",
      documentable_id: "",
      file_error: "",
      file_category: "",
      waiting: false,
      page: 2,
    },
  ];

  public static address_call_option_a: Partial<ValidationQuestion>[] = [
    {
      type: "information",
      information: `"En caso de aprobar su solicitud, la firma del contrato
        deberá ser en el domicilio declarado."`,
      additional_information: "Comentar lo siguiente:",
      control: "address-information",
      answer: { value: "no value" },
      page: 1,
    },
  ];

  public static address_call_option_b: Partial<ValidationQuestion>[] = [
    {
      type: "radio-confirm",
      question_confirm: `¿Reconoce el siguiente domicilio?`,
      control: "recognized-address",
      show_confirm_label: true,
      answer_confirm: undefined,
      options: [
        { label: "Sí", value: { value: "si" } },
        { label: "No", value: { value: "no", show_in_resume: "true" } },
      ],
      answer: undefined,
      page: 1,
    },
    {
      type: "radio-confirm-textbox",
      question_confirm: `¿A qué nombre está el comprobante
      de domicilio que nos proporcionó y que relación tiene con
      esa persona?`,
      control: "address-proof-related",
      options: [
        { label: "Sí", value: "si" },
        { label: "No", value: "other" },
      ],
      answer: undefined,
      answer_confirm: undefined,
      show_confirm_label: false,
      label: "Relación con Titular del Comprobante",
      page: 1,
    },
    {
      type: "select-time",
      question: `¿Cuánto tiempo ha vivido en su domicilio actual?`,
      control: "time-in-address",
      answer: undefined,
      answer_year: undefined,
      answer_month: undefined,
      year_options: GeneralUtilities.year_options,
      month_options: GeneralUtilities.month_options,
      show_confirm_label: true,
      label: "Arraigo Domiciliario",
      page: 1,
    },
    {
      type: "radio-confirm",
      question_confirm: `¿Qué dirección aparece en sus estados de cuenta?`,
      control: "address-in-income-proof",
      show_confirm_label: true,
      answer: undefined,
      options: [
        { label: "Sí", value: { value: "si" } },
        { label: "No", value: { value: "no", show_in_resume: "true" } },
      ],
      page: 2,
    },
    {
      type: "radio-confirm",
      question_confirm: `¿Qué dirección aparece en su identificación?`,
      control: "address-in-id",
      show_confirm_label: false,
      answer: undefined,
      options: [
        { label: "Sí", value: { value: "si" } },
        { label: "No", value: { value: "no", show_in_resume: "true" } },
      ],
      page: 2,
    },
    {
      type: "radio-confirm-textbox",
      question_confirm: `¿Reconoce este domicilio? ¿Cuál es su relación?`,
      control: "address-proof-related-bank",
      show_confirm_label: false,
      options: [
        { label: "Sí", value: "other" },
        { label: "No", value: "no" },
      ],
      answer_confirm: undefined,
      answer: undefined,
      label: "Relación con Domicilio en Estados de Cuenta",
      page: 2,
    },
  ];

  public static bureau_addresses: Partial<ValidationQuestion> = {
    type: "radio-confirm-textbox",
    question_confirm: `¿Reconoce este domicilio? ¿Cuál es su relación?`,
    control: "address-proof-bureau",
    show_confirm_label: true,
    confirm_label: "¿Reconoce el domicilio?",
    options: [
      { label: "Sí", value: "other" },
      { label: "No", value: "no" },
    ],
    answer_confirm: undefined,
    answer: undefined,
    label: "Relación con Domicilio en Buró de Crédito",
    page: 1,
  };

  public static reason_proof_do_not_exist: Partial<ValidationQuestion> = {
    type: "textbox",
    question: `¿Por qué no hay un registro de su comprobante de pago en CFE?`,
    control: "reason-proof-do-not-exist",
    answer: undefined,
    label: "Respuesta",
    page: 1,
  };

  public static reason_not_constant_consume: Partial<ValidationQuestion> = {
    type: "textbox",
    question: `¿Por qué no es constante su consumo de luz?`,
    control: "reason-not-constant-consume",
    answer: undefined,
    label: "Respuesta",
    page: 1,
  };

  public static address_call_option_c: Partial<ValidationQuestion>[] = [
    {
      type: "radio-confirm",
      question_confirm: `Elige un domicilio falso y pregunta si lo reconoce.`,
      control: "fake-addresses",
      confirm_label: "¿Reconoce el domicilio?",
      show_confirm_label: true,
      answer_confirm: `Querétaro:
        C. Miguel Hidalgo 110, Colinas del Cimatario, 76090 Santiago de Querétaro, Qro.
        GTO:
        C. Jacarandas 150 Col. Valle del Sol, San Francisco del Rincón, Gto.
        Nayarit:
        Circuito poetas 29, Jardines de Matatipac, Xalisco, Nayarit.
        Jalisco:
        Filósofos 89 Tepeyac 45150 Zapopan, Jalisco.
        Morelos: 
        15 de septiembre 545, Nueva Santa Maria, Cuernavaca, Morelos.
        CDMX
        Gandhi 92, Anzures, Miguel Hidalgo, CDMX
        TOLUCA:
        Roble 16, San Buenaventura, Toluca de Lerdo, Méx.`,
      options: [
        { label: "Sí", value: { value: "si", show_in_resume: "true" } },
        { label: "No", value: { value: "no" } },
      ],
      page: 1,
    },
    {
      type: "select-time",
      question: `¿Cuánto tiempo ha vivido en su domicilio actual?`,
      control: "time-in-address",
      answer: undefined,
      answer_year: undefined,
      answer_month: undefined,
      year_options: GeneralUtilities.year_options,
      month_options: GeneralUtilities.month_options,
      show_confirm_label: true,
      label: "Arraigo Domiciliario",
      page: 2,
    },
    {
      type: "radio-textbox",
      question: `¿El domicilio en donde vives es propio o es rentado?`,
      control: "own-or-rent",
      options: [
        { label: "Propio", value: { value: "own" } },
        { label: "Rentado", value: { value: "other" } },
      ],
      answer: undefined,
      label: "Renta ($)",
      alternative_question: "¿Cuánto pagas de renta?",
      page: 2,
    },
    {
      type: "textbox",
      question: `¿Con quién vives actualmente?`,
      control: "lives-with",
      answer: undefined,
      label: "Cohabitantes del Domicilio Declarado",
      page: 2,
    },
    {
      type: "textbox",
      question: `¿Podrías describir la fachada del domicilio?`,
      control: "house-description",
      answer: undefined,
      label: "Descripción Fachada",
      page: 3,
    },
    {
      type: "evidence-button-option",
      question_inside: "¿Realizar búsqueda web?",
      control: "web-search",
      options: [
        { label: "Sí, buscar ahora", btn_class: "btn-blue", value: "now" },
        { label: "Sí, después de la llamada", btn_class: "btn-blue", value: "after_call" },
      ],
      answer: undefined,
      alternative_answer: undefined,
      alternative_title: "¿Por qué no se realizará la búsqueda web?",
      show_documents: false,
      select_option: "maps",
      page: 3,
    },
  ];

  public static identification_call: Partial<ValidationQuestion>[] = [
    {
      type: "radio-confirm-textbox",
      question_confirm: "¿Contestó el titular?",
      answer_confirm: undefined,
      control: "titular_answered",
      options: [
        { label: "Sí", value: "si" },
        { label: "No", value: "other" },
      ],
      answer: undefined,
      show_confirm_label: true,
      label: "Relación con Titular",
      page: 1,
    },
    {
      type: "radio-confirm",
      question_confirm: "¿Cual es su nombre completo?",
      answer_confirm: undefined,
      control: "confirm_name",
      options: [
        { label: "Sí", value: { value: "si" } },
        { label: "No", value: { value: "no", show_in_resume: "true" } },
      ],
      answer: undefined,
      show_confirm_label: false,
      page: 1,
    },
    {
      type: "radio-confirm",
      question_confirm: "¿Cual es su fecha de nacimiento?",
      answer_confirm: undefined,
      control: "confirm_birtdhate",
      options: [
        { label: "Sí", value: { value: "si" } },
        { label: "No", value: { value: "no", show_in_resume: "true" } },
      ],
      answer: undefined,
      show_confirm_label: false,
      page: 1,
    },
    {
      type: "radio-confirm",
      question_confirm: "¿Cuál es su correo electrónico?",
      answer_confirm: undefined,
      control: "confirm_email",
      options: [
        { label: "Sí", value: { value: "si" } },
        { label: "No", value: { value: "no", show_in_resume: "true" } },
      ],
      answer: undefined,
      show_confirm_label: false,
      page: 2,
    },
    {
      type: "radio-confirm",
      question_confirm: "¿Cuál es su teléfono?",
      answer_confirm: undefined,
      control: "confirm_phone",
      options: [
        { label: "Sí", value: { value: "si" } },
        { label: "No", value: { value: "no", show_in_resume: "true" } },
      ],
      answer: undefined,
      show_confirm_label: false,
      page: 2,
    },
    {
      type: "phone",
      question: "¿Me puede compartir otro teléfono personal?",
      additional_information: "Presiona el botón agregar para guardar el teléfono en la información personal",
      control: "new_phone",
      answer: undefined,
      waiting: false,
      page: 3,
    },
    {
      type: "radio-confirm",
      question_confirm: "¿Cuál es el auto que está comprando?",
      answer_confirm: "",
      control: "confirm_car_model",
      options: [
        { label: "Sí", value: { value: "si" } },
        { label: "No", value: { value: "no", show_in_resume: "true" } },
      ],
      answer: undefined,
      show_confirm_label: false,
      page: 3,
    },
    {
      type: "evidence-button-option",
      question_inside: "¿Realizar búsqueda web?",
      control: "web-search",
      options: [
        { label: "Sí, buscar ahora", btn_class: "btn-blue", value: "now" },
        { label: "Sí, después de la llamada", btn_class: "btn-blue", value: "after_call" },
        { label: "No", btn_class: "btn-red", value: "other" },
      ],
      answer: undefined,
      alternative_answer: undefined,
      alternative_title: "¿Por qué no se realizará la búsqueda web?",
      show_documents: true,
      documents_id: [],
      documents: [],
      page: 4,
    },
    {
      type: "select-additional-option",
      question: "¿Cuál es el uso del vehículo?",
      options: GeneralUtilities.car_use_options,
      control: "car_use",
      answer: undefined,
      label: "Uso del Vehículo",
      page: 5,
    },
  ];

  public static employee_questions: Partial<ValidationQuestion>[] = [
    {
      type: "textbox",
      question: "¿Cuál es tu puesto?",
      control: "identification_name",
      answer: undefined,
      label: "Puesto",
      page: 1,
    },
    {
      type: "textbox",
      question: "¿Cuáles son las funciones más importantes que desempeñas?",
      control: "job_description",
      answer: undefined,
      label: "Descripción funciones",
      page: 1,
    },
    {
      type: "confirm-question-select",
      question_confirm: "¿Cuánto tiempo tienes ejerciendo esta actividad?",
      answer_confirm: undefined,
      control: "confirm_seniority",
      options: [
        { label: "Sí", value: "si" },
        { label: "No", value: "other" },
      ],
      answer: undefined,
      show_confirm_label: true,
      select_title: "Arraigo Laboral",
      label: "Arraigo Laboral",
      select_options: GeneralUtilities.job_time_options,
      page: 2,
    },
    {
      type: "textbox",
      question: "¿Cuál es el nombre de tu jefe directo y cuál es su puesto?",
      control: "boss_name",
      answer: undefined,
      label: "Nombre de jefe directo",
      page: 2,
    },
    {
      type: "textbox",
      question: "¿Dónde se encuentra tu centro de trabajo/operaciones/oficina?",
      control: "work_place",
      answer: undefined,
      label: "Domicilio Actividad Económica",
      page: 3,
    },
    {
      type: "textbox-checkbox",
      question: "¿Teléfono del lugar?",
      control: "work_phone",
      answer: undefined,
      label: "Teléfono Actividad Económica",
      checkbox_label: "No cuenta con otro teléfono",
      update_on: "blur",
      pattern: "[0-9]{10}",
      max_length: 10,
      min_length: 10,
      pattern_error: "Se requieren 10 caracteres numéricos",
      page: 3,
    },
    {
      type: "radio-textbox",
      question: "¿Hay salidas y entradas de efectivo en periodos muy cortos por cantidades similares?",
      control: "often_money_flow",
      options: [
        { label: "Sí", value: { value: "other" } },
        { label: "No", value: { value: "no" } },
      ],
      answer: undefined,
      alternative_question: "¿Por qué hay entradas y salidades de efectivo tan recurrentes?",
      label: "Entradas y Salidas de Efectivo Recurrente",
      page: 3,
    },
    {
      type: "evidence-button-option",
      question_inside: "¿Realizar búsqueda web?",
      control: "web-search",
      options: [
        { label: "Sí, buscar ahora", btn_class: "btn-blue", value: "now" },
        { label: "Sí, después de la llamada", btn_class: "btn-blue", value: "after_call" },
        { label: "No", btn_class: "btn-red", value: "other" },
      ],
      answer: undefined,
      alternative_answer: undefined,
      alternative_title: "¿Por qué no se realizará la búsqueda web?",
      show_documents: false,
      page: 4,
    },
    {
      type: "radio",
      question: "¿Esta es tu actividad económica principal?",
      control: "principal_activity",
      options: [
        { label: "Sí", value: { value: "si" } },
        { label: "No", value: { value: "no" } },
      ],
      answer: undefined,
      page: 4,
    },
    {
      type: "button-option",
      question: "¿Tiene alguna otra actividad económica?",
      control: "additional-activity",
      options: [
        { label: "Sí, Registrar", value: { value: "si" } },
        { label: "No", value: { value: "no" } },
      ],
      answer: undefined,
      page: 4,
    },
  ];

  public static retired_questions: Partial<ValidationQuestion>[] = [
    {
      type: "confirm-question-select",
      question_confirm: "¿Cuánto tiempo lleva de jubilación?",
      answer_confirm: undefined,
      control: "confirm_seniority",
      options: [
        { label: "Sí", value: "si" },
        { label: "No", value: "other" },
      ],
      answer: undefined,
      show_confirm_label: true,
      select_title: "Arraigo Laboral",
      label: "Arraigo Laboral",
      select_options: GeneralUtilities.job_time_options,
      page: 1,
    },
    {
      type: "textbox",
      question: "¿Dónde laboró antes de jubilarse?",
      control: "work_place",
      answer: undefined,
      label: "Empresa",
      page: 1,
    },
    {
      type: "textbox",
      question: "¿Cuánto percibe mensualmente como parte de su jubilación?",
      control: "work_remuneration",
      answer: undefined,
      label: "Ingresos Mensuales",
      page: 2,
    },
    {
      type: "evidence-button-option",
      question_inside: "¿Realizar búsqueda web?",
      control: "web-search",
      options: [
        { label: "Sí, buscar ahora", btn_class: "btn-blue", value: "now" },
        { label: "Sí, después de la llamada", btn_class: "btn-blue", value: "after_call" },
        { label: "No", btn_class: "btn-red", value: "other" },
      ],
      answer: undefined,
      alternative_answer: undefined,
      alternative_title: "¿Por qué no se realizará la búsqueda web?",
      show_documents: false,
      page: 2,
    },
    {
      type: "radio",
      question: "¿Esta es tu actividad económica principal?",
      control: "principal_activity",
      options: [
        { label: "Sí", value: { value: "si" } },
        { label: "No", value: { value: "no" } },
      ],
      answer: undefined,
      page: 3,
    },
    {
      type: "button-option",
      question: "¿Tiene alguna otra actividad económica?",
      control: "additional-activity",
      options: [
        { label: "Sí, Registrar", value: { value: "si" } },
        { label: "No", value: { value: "no" } },
      ],
      answer: undefined,
      page: 3,
    },
  ];

  public static independent_questions: Partial<ValidationQuestion>[] = [
    {
      type: "textbox",
      question: "¿Quiénes son tus principales clientes y cuánto te depositan en promedio al mes?",
      control: "principal_clients",
      answer: undefined,
      label: "Principales clientes",
      page: 1,
    },
    {
      type: "textbox",
      question: "¿Quiénes son tus principales proveedores y cuánto les pagas en promedio al mes?",
      control: "principal_providers",
      answer: undefined,
      label: "Principales proveedores",
      page: 1,
    },
    {
      type: "confirm-question-select",
      question_confirm: "¿Cuánto tiempo tienes ejerciendo esta actividad?",
      answer_confirm: undefined,
      control: "confirm_seniority",
      options: [
        { label: "Sí", value: "si" },
        { label: "No", value: "other" },
      ],
      answer: undefined,
      show_confirm_label: true,
      select_title: "Arraigo Laboral",
      label: "Arraigo Laboral",
      select_options: GeneralUtilities.job_time_options,
      page: 2,
    },
    {
      type: "textbox",
      question: "¿Dónde se encuentra tu centro de trabajo/operaciones/oficina?",
      control: "work_place",
      answer: undefined,
      label: "Domicilio Actividad Económica",
      page: 2,
    },
    {
      type: "textbox-checkbox",
      question: "¿Teléfono del lugar?",
      control: "work_phone",
      answer: undefined,
      label: "Teléfono Actividad Económica",
      checkbox_label: "No cuenta con otro teléfono",
      update_on: "blur",
      pattern: "[0-9]{10}",
      max_length: 10,
      min_length: 10,
      pattern_error: "Se requieren 10 caracteres numéricos",
      page: 3,
    },
    {
      type: "radio-textbox",
      question: "¿Hay salidas y entradas de efectivo en periodos muy cortos por cantidades similares?",
      control: "often_money_flow",
      options: [
        { label: "Sí", value: { value: "other" } },
        { label: "No", value: { value: "no" } },
      ],
      answer: undefined,
      alternative_question: "¿Por qué hay entradas y salidades de efectivo tan recurrentes?",
      label: "Entradas y Salidas de Efectivo Recurrente",
      page: 3,
    },
    {
      type: "textbox",
      question: `Dado que puedan ser variables sus ingresos, ¿cuenta con algún
        ahorro adicional en caso de presentar malas rachas?`,
      control: "additional_saving",
      answer: undefined,
      label: "Variabilidad en Ingresos",
      page: 3,
    },
    {
      type: "evidence-button-option",
      question_inside: "¿Realizar búsqueda web?",
      control: "web-search",
      options: [
        { label: "Sí, buscar ahora", btn_class: "btn-blue", value: "now" },
        { label: "Sí, después de la llamada", btn_class: "btn-blue", value: "after_call" },
        { label: "No", btn_class: "btn-red", value: "other" },
      ],
      answer: undefined,
      alternative_answer: undefined,
      alternative_title: "¿Por qué no se realizará la búsqueda web?",
      show_documents: false,
      page: 4,
    },
    {
      type: "radio",
      question: "¿Esta es su actividad económica principal?",
      control: "principal_activity",
      options: [
        { label: "Sí", value: { value: "si" } },
        { label: "No", value: { value: "no" } },
      ],
      answer: undefined,
      page: 4,
    },
    {
      type: "button-option",
      question: "¿Tiene alguna otra actividad económica?",
      control: "additional-activity",
      options: [
        { label: "Sí, Registrar", value: { value: "si" } },
        { label: "No", value: { value: "no" } },
      ],
      answer: undefined,
      page: 4,
    },
  ];

  public static buro_address: Partial<ValidationQuestion> = {
    type: "calculated",
    question: "Domicilio ingresado al buró de crédito.",
    control: "buro_address_proof",
    answer: { value: undefined },
  };

  public static additional_address: Partial<ValidationQuestion> = {
    type: "calculated",
    question: "Domicilio ingresado a las direcciones.",
    control: "additional_address",
    answer: { value: undefined, type: undefined },
  };

  public static address_pad_call: Partial<ValidationQuestion>[] = [
    {
      type: "address-validation",
      control: "address-sign-contract",
      options: [
        { label: "No", btn_class: "btn-red", value: "no" },
        { label: "Sí", btn_class: "btn-green", value: "yes" },
      ],
      answer: undefined,
      validation_process_id: undefined,
      additional_question: "¿El domicilio en el mapa corresponde al domicilio actual?",
      forward_next_page: false,
      page: 1,
    },
  ];

  public static same_sign_address_additional_questions: Partial<ValidationQuestion> = {
    type: "information",
    information: `"En caso de aprobar su solicitud, la firma del contrato
      deberá ser en el domicilio declarado."`,
    additional_information: "Comentar lo siguiente:",
    control: "address-information",
    answer: { value: "no value" },
    page: 2,
  };

  public static different_sign_address_additional_questions: Partial<ValidationQuestion>[] = [
    {
      type: "select-additional-option",
      question: `¿A dónde corresponde el domicilio en el mapa?`,
      control: "address-relation",
      answer: undefined,
      show_confirm_label: true,
      label: "Relación Domicilio en Mapa",
      options: GeneralUtilities.address_categories,
      page: 1,
    },
    {
      type: "textbox",
      question: "¿Cuál es el domicilio en donde está viviendo actualmente?",
      control: "current-address",
      answer: undefined,
      show_confirm_label: true,
      label: "Domicilio",
      page: 2,
    },
    {
      type: "select-time",
      question: `¿Cuánto tiempo ha vivido en su domicilio actual?`,
      control: "time-in-address",
      answer: undefined,
      answer_year: undefined,
      answer_month: undefined,
      year_options: GeneralUtilities.year_options,
      month_options: GeneralUtilities.month_options,
      show_confirm_label: true,
      label: "Arraigo Domiciliario",
      page: 2,
    },
  ];

  public static regions_fake_address = {
    Centro: `<b>Pachuca:</b> Bugambilia 12 Real del Valle Pachuca de Soto
      <b>Pachuca:</b> Circuito economistas 34 El Palmar Pachuca de Soto
      <b>Tlaxcala:</b> Morelos 879, La Trasquila Tlaxcala
      <b>Tlaxcala:</b> República de Chile 3, Tetla, Tlaxcala
      <b>Puebla:</b> Sor Juana Inés de la Cruz 498, Tehuacán Puebla
      <b>Puebla:</b> Avenida los Pinos 67, Agua Santa Puebla
      <b>Querétaro:</b> C. Miguel Hidalgo 110, Colinas del Cimatario, 76090 Santiago de Querétaro, Qro.
      <b>Guanajuato:</b> C. Jacarandas 150 Col. Valle del Sol, San Francisco del Rincón, Gto.
      <b>Nayarit:</b> Circuito poetas 29, Jardines de Matatipac, Xalisco, Nayarit.
      <b>Jalisco:</b> Filósofos 89 Tepeyac 45150 Zapopan, Jalisco.
      <b>Morelos:</b> 15 de septiembre 545, Nueva Santa Maria, Cuernavaca, Morelos.
      <b>Cuernavaca:</b> Laureles 98, jardines las delicias, cuernavaca morelos
      <b>CDMX:</b> Gandhi 92, Anzures, Miguel Hidalgo, CDMX
      <b>TOLUCA:</b> Roble 16, San Buenaventura, Toluca de Lerdo, Méx.`,
    Norte: `
      <b>Monterrey:</b> Adolfo Lopez Mateos 9, Obispado, Monterrey
      <b>Monterrey:</b> Lerma 123, Independencia, Monterrey
      <b>Saltillo:</b> Ejercito Nacional 765, Las Teresitas, Saltillo
      <b>Saltillo:</b> Bosque Real 5, Loma Blanca Santillo
      <b>Torreón:</b> Joaquín Sabina SN, Nueva Laguna Norte, Torreón
      <b>Torreón:</b> Galdivia 29, Jardines de California, Torreón
      <b>Monclova:</b> Sierra Madre 79, Santa Fe, Monclova
      <b>Monclova:</b> Xochimiclo 45, Charco Azul, Monclova
      <b>Sabinas:</b> Balderas 678, Fundadores, Sabinas Coahuila
      <b>Sabinas:</b> El dorado 35, Nuevo Amanecer, Sabinas Coahuila
      <b>Piedras Negras:</b> Escape SN, Lomas del Norte, Piedras Negras
      <b>Piedras Negras:</b> Castores 23, Rio Escondido, Piedras Negras
      <b>Ciudad Juarez:</b> Pino Suarez 90, Rancho Palo Chino, Cuidad Juarez
      <b>Ciudad Juarez:</b> Juanacatlan 56, Zaragoza, Ciudad Juarez
      <b>Chihuahua:</b> Huaizachal 31, San Rafael, Chihuahua
      <b>Chihuahua:</b> Carlos V 89, La Paz, Chihuahua
      <b>Tijuana:</b> Monte Alban 10, Azcona, Tijuana
      <b>Tijuana:</b> Cto Sevilla 7, Colinas del rey, Tijuana
      <b>Hermosillo:</b> Av Trinidad 69, Jesus Garcia, Hermosillo Sonora
      <b>Hermosillo:</b> Cerrada Gladiolas 9, La caridad, Hermosillo, Sonora
      <b>Ciudad Victoria:</b> Francisco I Madero 82, Niños Heroes, Ciudad Victoria
      <b>Ciudad Victoria:</b> Gardenias 5, Los Fresnos, Ciudad Victoria
      <b>Reynosa:</b> Bosques de Yuriria 9, Las Cumbres, Reynosa Tamaulipas
      <b>Reynosa:</b> Viaducto Izazaga 13, Puerta Del Sol, Reynosa Tamaulipas
      <b>Tampico:</b> Andador Huisache 34, Lomas De Los Rosales, Tampico
      <b>Tampico:</b> Jardines De Murillo 78, Colinas Del Sol, Tampico
    `,
    Sur: `
      <b>Campeche:</b> Cerrada Jilotzingo 23, Ampliacion Polvorin, Campeche
      <b>Campeche:</b> Niños Heroes 4, Nueva Era, Campeche
      <b>Tuxtla Gutierrez:</b> Turin 89, Bella Vista, Tuxtla Gutierrez:
      <b>Tuxtla Gutierrez:</b> Av Las Cruces 45, Quinta Sarita, Tuxtla Gutierrez
      <b>Villahermosa:</b> Cerrada Murillo 21, Tamulte De Las Barrancas, Villahermosa
      <b>Villahermosa:</b> Tulipanes 78, Casa Blanca, Villahermosa
      <b>Oaxaca:</b> Olimpiada 68, Trinidad De Las Huertas, Oaxaca
      <b>Oaxaca:</b> Rio Nilo 30, Santa Maria Del Marquesado, Oaxaca
      <b>Acapulco:</b> Sendero A La Huasca 70, 20 De Noviembre, Acapulco Guerrero
      <b>Acapulco:</b> Division Del Norte 65, Piedra Roja, Acapulco Guerrero
      <b>Veracruz:</b> Av Jamaica 3, Acayucan, Veracruz
      <b>Veracruz:</b> Cerrada Naranjos 38, Coatepec, Veracruz
      <b>Xalapa:</b> Cto Urales 29, Tronconal, Xalapa Veracruz
      <b>Xalapa:</b> Cerrada Jonh F Kennedi 9, El Roble, Xalapa Veracruz
      <b>Poza Rica:</b> Noche Buena 6, Residencial La Ilusion, Poza Rica De Hidalgo
      <b>Poza Rica:</b> Av Barcelona 2, Cazones, Pozarica De Hidalgo
      <b>Cordoba:</b> Boulevard Vista Hermosa 82, Residencial Shangrila, Cordoba
      <b>Cordoba:</b> Av Manzanillo 9, Jose Maria Morelos, Cordoba
      <b>Coatzacoalcos:</b> Prolongacion 30 De Octubre 28, Maria De La Piedad, Coatzacoalcos
      <b>Coatzacoalcos:</b> Ingenieros Militares 7, Nueva Obrera, Coatzacoalcos
    `,
    "Centro-Norte": `
      <b>Colima:</b> Av Maria Merced 21, La Albarrada, Colima
      <b>Colima:</b> Cerrada Cubilete 9, Colinas De Santa Barbara, Colima
      <b>Tepic:</b> Venus 7, Benito Juarez Ote, Tepic
      <b>Tepic:</b> Jacaranda Sn, Lomas Altas, Tepic
      <b>San Luis Potosi:</b> Boulevard Montesori Sn, Industrial San Luis, San Luis Potosi
      <b>San Luis Potosi:</b> Av La Conchita 75, Progreso, San Luis Potosi
      <b>Zacatecas:</b> Av Escape 65, La Encantada, Zacatecas
      <b>Zacatecas:</b> Glorieta La Terronera 10, Lomas De La Pimienta, Zacatecas
      <b>Aguascalientes:</b> Navidad 25, San Cayetano, Aguascalientes
      <b>Aguascalientes:</b> San Lorenzo 4, Villa De Las Norias Aguascalientes
    `,
    "Norte-Occidente": `
      <b>Durango:</b> Huichapan 345, Industrial Ladrillera, Victoria De Durango
      <b>Durango:</b> Hacienda Flores 90, 20 De Noviembre, Victoria De Durango
      <b>Gomez Palacio:</b> Av Escritores 876, Miguel De La Madrid, Gomez Palacios
      <b>Gomez Palacio:</b> Cto Escandon 23, Fidel Velazquez, Gomez Palacios
    `,
  };
}
